module.exports = __webpack_public_path__ + "static/img/weibo-select.3d5fa60f.svg";